export enum IntakeFormSectionDataHook {
  ROOT = 'intake-form-section-root',
  FORM_CARD = 'intake-form-card',
  SECTION_CONTAINER = 'intake-form-section-container',
  SECTION_TITLE = 'intake-form-section-title',
  FORM_TITLE = 'intake-form-title',
  REQUIRED_INDICATOR = 'intake-form-required-indicator',
  COMPLETED_ICON = 'intake-form-completed-icon',
  SECTION_SUBTITLE = 'intake-form-section-subtitle',
  FILL_FORM_BUTTON = 'intake-form-fill-form-button',
}
